import { render, staticRenderFns } from "./objCustomTextSelected.vue?vue&type=template&id=b3f5b2f2&"
import script from "./objCustomTextSelected.vue?vue&type=script&lang=ts&"
export * from "./objCustomTextSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports